var CommSummary = React.createClass({
  propTypes: {
    searchResults: React.PropTypes.object.isRequired,
    eventHandler: React.PropTypes.func.isRequired,
    resultCount: React.PropTypes.number,
    categoryCount: React.PropTypes.number
  },
  getDefaultProps() {
    return {
      resultCount: 5,
      categoryCount: 2
    }
  },
  communityClicked(id) {
    this.props.eventHandler({actionType: 'communityChanged', communityID: id});
    this.showCommunityTab();
  },
  showCommunityTab() {
    RA.ResultsPage.showTab("#commResults");
  },
  getSummaryHits() {
    let results = this.props.searchResults.results;
    let ubound = Math.min(results.length, this.props.resultCount);

    return results.slice(0, ubound);
  },
  getSummaryCommunities() {
    let communities = this.props.searchResults.communities;

    // sort affects other components using this variable - use map, then sort instead
    //communities.sort((a, b) => b.hits - a.hits);

    // convert to map of array {index, hit count}
    let hitCounts = communities.map((cat, i) => {
      return {index: i, count: cat.hits }
    });

    // sort by hit count - descending
    hitCounts.sort((a, b) => b.count - a.count);

    // get slice
    let ubound = Math.min(hitCounts.length, this.props.categoryCount);
    hitCounts = hitCounts.slice(0, ubound);

    // return array of communities with index position from the hitCount array
    return hitCounts.map(hitCount => {
      return communities[hitCount.index];
    });
  },
  renderSummary() {
    let { searchResults } = this.props;

    if (searchResults.totalHits == 0) {
      return <NoResults />
    }

    let resultsLabel = searchResults.totalHits == 1 ? "result" : "results";
	let didYouMean = searchResults.didyoumean;

    return (
      <div>
        <div className="result-summary__stats">
          <span className="text-muted">{`${searchResults.totalHits} ${resultsLabel} - `}</span>
          <a href="#" className="text-muted" onClick={this.showCommunityTab}>
            {Labels.getLabel("Show All")}
          </a>
		  <CommDidYouMean didYouMean={didYouMean}/>
        </div>
        <CommResultsList hits={this.getSummaryHits()} showAuthor={false} showCommunityPath={false} />
        <CommSummaryCommunities communities={this.getSummaryCommunities()}
          onCommunityClicked={this.communityClicked} />
      </div>
    )
  },

  render() {
     return (
      <div>
        <h3 className="result-summary__head">
          <a href="#" className="result-summary__head-link -comm" onClick={this.showCommunityTab}>
            <i className="glyphicon glyphicon-comment result-summary__head-icon"></i>
            {Labels.getLabel("Communities")}
          </a>
        </h3>

        {this.renderSummary()}
      </div>
    )
  }
});